import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { useAddExclusionMutation } from 'queries/wage/useAddExclusionMutation'
import { parseErrorMessage } from 'api'

type AddExclusionFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<typeof useAddExclusionMutation>['mutate']
  }
}

const [Context, useAddExclusionFlowContextValue] =
  createContext<AddExclusionFlowContextState>({
    name: 'AddExclusionFlowContext',
  })

export const AddExclusionFlowProvider = ({
  children,
  ruleId,
}: PropsWithChildren<{ ruleId: number }>) => {
  const { mutate, isPending, error } = useAddExclusionMutation(ruleId)

  const value: AddExclusionFlowContextState = {
    state: {
      mutationState: {
        isPending,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: { submit: mutate },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useAddExclusionFlowContextValue }
